module.exports = __webpack_public_path__ + "static/media/p5.203c849d.png";